import {
  IdObject,
  Nullable,
  PayoutType,
  PayoutStatus,
  SearchRequest,
  PayoutAdjustmentReason,
} from 'types';

import { Event } from '../event';
import { Employee } from '../employees';
import { PaymentMethod } from '../payment-methods';
import { AccountingCategory } from '../accounting/types';

export interface Payout extends IdObject {
  miscGroup?: 'positive' | 'negative' | null;
  canEditManual?: boolean;
  canRemoveManual?: boolean;
  date: string;
  event?: Event;
  amount: number;
  notes?: string;
  type: PayoutType;
  eventId?: number;
  createdAt: string;
  refundId?: number;
  employee: Employee;
  employeeId: number;
  updatedAt?: string;
  checkoutId?: number;
  categoryId?: number;
  receiptUrl?: string;
  status: PayoutStatus;
  reasonReject?: string;
  originalEvent?: Event;
  requestAmount?: number;
  originalEventId?: number;
  paymentMethod?: PaymentMethod;
  category?: AccountingCategory;
  paymentMethodId?: Nullable<number>;
  adjustmentReason?: PayoutAdjustmentReason;
  payout?: {
    id: number;
    paymentMethod?: PaymentMethod;
    paymentMethodId?: Nullable<number>;
  };
}

export interface PaymentHistory
  extends Pick<Payout, 'date' | 'notes' | 'employee' | 'employeeId'>, IdObject {
  total: number;
  items: Payout[];
  paymentMethod?: PaymentMethod;
  paymentMethodId?: Nullable<number>;
}

export interface CreatePayoutRequest extends Omit<
  Payout,
  | 'id'
  | 'event'
  | 'status'
  | 'employee'
  | 'createdAt'
  | 'employeeId'
  | 'reasonReject'
> {
  employeeId?: number;
}

export interface PayoutListRequest {
  id?: string;
  month?: string;
  types?: string;
  eventId?: string;
  onlyLead?: boolean;
  employeeId?: string;
  status?: PayoutStatus;
}

export interface ChangeStatusRequest extends IdObject {
  amount?: number;
  status: PayoutStatus;
  reasonReject?: string;
}

export interface EditPayoutRequest extends CreatePayoutRequest, IdObject {
  employeeId: number;
}

export interface PayrollPayoutItemRequest extends IdObject {
  amount?: number;
}

export interface CreatePayrollRequest {
  employeeId: number;
  paymentMethodId: number;
  payoutItems: PayrollPayoutItemRequest[];
}

export type PaymentHistoryRequest = IdObject &
  SearchRequest & { month?: string; timeZone?: string };

export const MinusPayoutTypes = [
  PayoutType.Misc,
  PayoutType.Refund,
  PayoutType.Advance,
  PayoutType.NegativeTip,
  PayoutType.FreeShipping,
  PayoutType.PrepaidAdvance,
  PayoutType.NegativeEarnings,
  PayoutType.NegativeAdjustment,
];

export interface PendingPayout {
  event: Event;
  payoutItems: Payout[];
  totalPayoutAmount: number;
}

export interface EmployeeSalaryRequest extends IdObject {
  month?: string;
  isUnpaidOnly?: boolean;
}
